/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React, { useEffect, useState } from "react";
import { GrClear } from "react-icons/gr";
import api from "../../../service/axios/api";

export function GlobalMetrics({ daysSelected, setDaysSelected }) {
    const [metrics, setMetrics] = useState({ days30: 0, days45: 0, days60: 0 })

    useEffect(() => {
        const cancel = new AbortController();
        api.order.reportByClientMetrics(cancel)
            .then((res) => {
                setMetrics({ days30: res.days30, days45: res.days45, days60: res.days60 })
            })
            .catch((err) => console.log(err))
    }, [])

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <div style={{ display: 'flex', gap: 10, with: '100%', justifyContent: 'center' }}>
                <div onClick={() => setDaysSelected('30')} style={{ width: '15%', color: '#6e6565', fontWeight: 'bold', textAlign: 'center', padding: '0.5rem 1.5rem 0 1.5rem', backgroundColor: 'yellow', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', border: daysSelected === '30' ? '2px solid blue' : '0px' }}>
                    <p>Inátivos <br />+30 <br />dias</p>
                    <h3>{metrics.days30}</h3>
                </div>
                <div onClick={() => setDaysSelected('45')} style={{ width: '15%', color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '0.5rem 1.5rem 0 1.5rem', backgroundColor: '#fd7e14', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', border: `${daysSelected === '45' ? '2px' : '0px'} solid blue` }}>
                    <p>Inátivos <br />+45 <br />dias</p>
                    <h3>{metrics.days45}</h3>
                </div>
                <div onClick={() => setDaysSelected('60')} style={{ width: '15%', color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '0.5rem 1.5rem 0 1.5rem', backgroundColor: 'red', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', border: `${daysSelected === '60' ? '2px' : '0px'} solid blue` }}>
                    <p>Inátivos <br />+60 <br />dias</p>
                    <h3>{metrics.days60}</h3>
                </div>

                {daysSelected !== '' && (
                    <div onClick={() => setDaysSelected('')} style={{ textAlign: 'center', padding: '0.5rem 1.5rem 0 1.5rem', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                        <GrClear size={30} />
                        <p>Limpar seleção</p>
                    </div>
                )}
            </div>
            {/* <div style={{ display: 'flex', gap: 10, width: '100%', justifyContent: 'center' }}>
                <div style={{ width: '100%', color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '0.5rem 2.5rem 0 2.5rem', backgroundColor: '#2c3e50', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h4>520</h4>
                    <p>Total de clientes</p>
                </div>

                <div style={{ width: '100%', color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '0.5rem 2.5rem 0 2.5rem', backgroundColor: '#2c3e50', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h4>5.120</h4>
                    <p>Total de cargas</p>
                </div>

                <div style={{ width: '100%', color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '0.5rem 2.5rem 0 2.5rem', backgroundColor: '#2c3e50', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h4>320</h4>
                    <p>Tocket médio</p>
                </div>

                <div style={{ width: '100%', color: 'white', fontWeight: 'bold', textAlign: 'center', padding: '0.5rem 2.5rem 0 2.5rem', backgroundColor: '#2c3e50', borderRadius: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h4>650</h4>
                    <p>Clientes usando ambos os Serviços</p>
                </div>
            </div> */}
        </div>
    )
}